export default __webpack_public_path__ + "static/media/wShoes_2_p2.7bfe373b.jpeg";